import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// @mui
import { Box, Drawer, Stack } from "@mui/material";
// hooks
import useResponsive from "../../../hooks/useResponsive";
// config
import { NAV } from "../../../config-global";
// components
import Logo from "../../../components/logo";
import { NavSectionVertical } from "../../../components/nav-section";
import Scrollbar from "../../../components/scrollbar";
//
import NavToggleButton from "./NavToggleButton";
import navConfig from "./config-navigation";
import contentManagerNavConfig from "./contentManager-navigation";
import managerNavConfig from "./manager-navigation";
import scorerNavConfig from "./scorer-navigation";
//
import { useAuthContext } from "../../../auth/useAuthContext";

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function NavVertical({ openNav, onCloseNav }) {
  // Logic here to get current user role
  const { user, permission } = useAuthContext();

  // const currentRole = 'user';
  // const currentRole = user.roles[0].name; // admin;

  const currentRole = user?.role?.name;

  const { pathname } = useLocation();

  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const roleConfigMap = {
    "Super Admin": navConfig,
    "Content Manager": contentManagerNavConfig,
    Manager: managerNavConfig,
    Scorer: scorerNavConfig,
    // Manager: managerNavConfig,
    // Leads: leadNavConfig,
    // Director: directorNavConfig,
  };

  // Select the appropriate config based on the currentRole

  const selectedConfig = roleConfigMap[currentRole];

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,

        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          // pb: 2,
          // px: 2.5,
          flexShrink: 0,
        }}
      >
        <Logo />
        <hr style={{ width: "90%", margin: "auto", marginTop: "22px" }} />
      </Stack>
      <div
        style={{
          paddingBottom: "25px",
        }}
      >
        <NavSectionVertical data={selectedConfig} />
      </div>
      <Box sx={{ flexGrow: 1 }} />

      {/* <NavDocs /> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: "transparent",
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
